import { useTranslate } from '@tolgee/react'
import { ConfirmationDialog } from '@tom-ui/ui'
import { appStore } from '@tom-ui/utils'
import { observer } from 'mobx-react-lite'
import { useYardSetupMessageHandler } from '../../hooks/useYardSetupMessageHandler'
import { IRailTrackFormData } from '../../models/yard-setup.model'
import { RailTrackViewStore } from '../../stores/nodes/rail-track.view-store'
import { RailTrackForm } from './RailTrackForm'

interface Props {
  railTrackViewStore: RailTrackViewStore
}

export const RailTrackDialogs = observer(({ railTrackViewStore }: Props) => {
  const { t } = useTranslate()
  const { getRailTrackSuccessMessage, getRailTrackDeleteSuccessMessage, getExceptionMessage } =
    useYardSetupMessageHandler()

  const onSubmit = async (data: IRailTrackFormData) => {
    try {
      await railTrackViewStore.submit(data)
      appStore.setShowAlert(
        'success',
        getRailTrackSuccessMessage(!!railTrackViewStore.focusedRailTrack),
      )
      railTrackViewStore.closeFormDialog()
    } catch (e: any) {
      appStore.setShowAlert('error', getExceptionMessage(e))
    }
  }

  const onDelete = async () => {
    try {
      await railTrackViewStore.delete(railTrackViewStore.editingId!)
      appStore.setShowAlert('success', getRailTrackDeleteSuccessMessage())
      railTrackViewStore.setDeleteDialogOpen()
    } catch (e: any) {
      appStore.setShowAlert('error', getExceptionMessage(e))
    }
  }

  return (
    <>
      <ConfirmationDialog
        open={railTrackViewStore.isFormDialogOpen}
        title={
          railTrackViewStore.focusedRailTrack
            ? t('editRailTrack', 'Edit rail track')
            : t('addRailTrack', 'Add rail track')
        }
        primaryActionText={
          railTrackViewStore.focusedRailTrack
            ? t('yesUpdate', 'Yes, update')
            : t('yesCreate', 'Yes, create')
        }
        closeLabel={t('noCancel', 'No, cancel')}
        formId='rail-track-form'
        onClose={() => railTrackViewStore.closeFormDialog()}
      >
        <RailTrackForm
          id='rail-track-form'
          railTrack={railTrackViewStore.focusedRailTrack}
          onSubmit={onSubmit}
        />
      </ConfirmationDialog>

      <ConfirmationDialog
        open={railTrackViewStore.isDeleteDialogOpen}
        title={t('deleteRailTrack', 'Delete rail track')}
        message={t('youCannotUndoThisAction', 'You cannot undo this action.')}
        primaryActionText={t('yesDelete', 'Yes, delete')}
        closeLabel={t('noCancel', 'No, cancel')}
        onClose={() => railTrackViewStore.setDeleteDialogOpen()}
        onConfirm={onDelete}
        maxWidth='xs'
      />
    </>
  )
})
